<template>
  <div id="header">
    <button type="button" class="header-btn" @click="toggleMenu()"><i class="fa fa-bars"></i></button>
    <span> Markdwon (GitHub Flavored Markdown) 코드랩</span>
    <span class="float-right">      
      <a href="https://stackedit.io/app" target="_blank" class="header-btn" title="Open StackEdit"><i class="fa fa-edit"></i></a>
      &nbsp; | &nbsp;
      <button type="button" class="header-btn" title="공지사항 확인" @click='$router.push("/notices")'>
        <i class="fa fa-bell-o"></i>
      </button>
      <button type="button" class="header-btn" title="치트시트 팝업"
        :class='{active: isShowCheatSheet}' @click='toggleSheet()'
      >
        <i class="fa fa-table"></i>
      </button>
      <button type="button" class="header-btn" @click="fontSizeDown()" title="글씨 작게하기"><i class="fa fa-minus-circle"></i></button>
      <button type="button" class="header-btn" @click="fontSizeUp()" title="글씨 크게하기"><i class="fa fa-plus-circle"></i></button>
    </span>
  </div>
</template>

<script>
import EventBus from "@/eventbus.js";

export default {
  name: "sb-header",
  props: {
    isShowCheatSheet: { type: Boolean, default: false }
  },
  methods: {
    toggleMenu(){ EventBus.$emit('MENU_TOGGLE'); } ,
    fontSizeUp(){ EventBus.$emit('PAGE_FONT_SIZEUP', this.isOpen); } ,
    fontSizeDown(){ EventBus.$emit('PAGE_FONT_SIZEDOWN', this.isOpen); },
    toggleSheet(){ this.$emit("toggle-sheet"); },
  }
}
</script>

<style>
#header {
  position: fixed;
  box-sizing: border-box;
  width: 100%;
  height: 64px;
  left: 0;
  z-index: 20;
  padding: 15px;
  background-color: #008080;
  color: #ffffff;
  font-size: 1.6em;
}

.float-right {
  color: white;
  float: right;
}
.header-btn{
  border: none;
  background: transparent;
  font-size: inherit;
  color: inherit;
  cursor: pointer;
}
.header-btn.active {
  color: #42b983;
}
</style>
